<template>
  <header class="site-header">
    <router-link class="brand" to="/">
      <img v-if="brand.showLogo && brand.logoUrl" :src="brand.logoUrl" alt="" />
      <span v-if="brand.showName">{{ brandName }}</span>
    </router-link>
    <nav class="nav">
      <router-link to="/policy">{{ t('navPolicy') }}</router-link>
      <router-link to="/submit">{{ t('navSubmit') }}</router-link>
      <router-link to="/advisories">{{ t('navAdvisories') }}</router-link>
      <a href="/security.txt">{{ t('navSecurity') }}</a>
    </nav>
    <button class="lang" type="button" @click="toggle">{{ locale === 'zh' ? t('langEn') : t('langZh') }}</button>
  </header>
</template>
<script>
import { t } from '../i18n'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'site-header',
  computed: {
    ...mapState(['locale', 'brand']),
    ...mapGetters(['brandName'])
  },
  methods: {
    t(key) {
      return t(this.locale, key)
    },
    toggle() {
      this.$store.commit('setLocale', this.locale === 'zh' ? 'en' : 'zh')
    }
  }
}
</script>
